export default __webpack_public_path__ + "static/media/CC.85a6dfa4.svg";